// Bilingual labels for the OOH counter screen.
// docs/CLINIC_WALKIN_QR_PLAN.md: when OOHScreenConfig.displayLanguage is one
// of "hi" | "kn" | "te", the OOH UI renders the English label with the local
// script alongside. Empty / unknown language = English only. Numbers (token
// values, names, etc.) are never translated.

export const SUPPORTED_LOCAL_LANGUAGES = [
  { code: 'hi', label: 'Hindi (हिन्दी)' },
  { code: 'kn', label: 'Kannada (ಕನ್ನಡ)' },
  { code: 'te', label: 'Telugu (తెలుగు)' },
]

const TRANSLATIONS = {
  currentToken: {
    en: 'Current Token',
    hi: 'वर्तमान टोकन',
    kn: 'ಪ್ರಸ್ತುತ ಟೋಕನ್',
    te: 'ప్రస్తుత టోకెన్',
  },
  nextToken: {
    en: 'Next Token',
    hi: 'अगला टोकन',
    kn: 'ಮುಂದಿನ ಟೋಕನ್',
    te: 'తదుపరి టోకెన్',
  },
  name: {
    en: 'Name',
    hi: 'नाम',
    kn: 'ಹೆಸರು',
    te: 'పేరు',
  },
  scanAndBook: {
    en: 'Scan & Book',
    hi: 'स्कैन करें और बुक करें',
    kn: 'ಸ್ಕ್ಯಾನ್ ಮಾಡಿ, ಬುಕ್ ಮಾಡಿ',
    te: 'స్కాన్ చేసి బుక్ చేయండి',
  },
  scanThisQr: {
    en: 'Scan with your phone camera to see the next available slot and book instantly.',
    hi: 'अगला उपलब्ध स्लॉट देखने और तुरंत बुक करने के लिए अपने फ़ोन कैमरे से स्कैन करें।',
    kn: 'ಮುಂದಿನ ಲಭ್ಯವಿರುವ ಸ್ಲಾಟ್ ನೋಡಲು ಮತ್ತು ತಕ್ಷಣವೇ ಬುಕ್ ಮಾಡಲು ನಿಮ್ಮ ಫೋನ್ ಕ್ಯಾಮೆರಾದಿಂದ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ.',
    te: 'తదుపరి అందుబాటులో ఉన్న స్లాట్‌ను చూడటానికి, తక్షణం బుక్ చేయడానికి మీ ఫోన్ కెమెరాతో స్కాన్ చేయండి.',
  },
  present: {
    en: 'IN',
    hi: 'उपस्थित',
    kn: 'ಹಾಜರು',
    te: 'హాజరు',
  },
  absent: {
    en: 'OUT',
    hi: 'अनुपस्थित',
    kn: 'ಗೈರು',
    te: 'గైరు',
  },
}

const SUPPORTED_LOCAL = new Set(SUPPORTED_LOCAL_LANGUAGES.map((l) => l.code))

/** Returns the English string for a key. */
export function en(key) {
  return TRANSLATIONS[key]?.en ?? ''
}

/** Returns the local-language string for a key, or '' if the lang isn't configured. */
export function local(key, language) {
  if (!language || !SUPPORTED_LOCAL.has(language)) return ''
  return TRANSLATIONS[key]?.[language] ?? ''
}
